var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('AboutAlorFeri',{staticClass:"py-4"}),_c('ServicesWeOffered',{staticClass:"py-4"}),_c('WhyChooseAlorFeri',{staticClass:"py-4"}),_c('TechnologyWeUse',{staticClass:"py-4"}),_c('OurTeam',{staticClass:"py-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }